<template>
  <div 
      :class="['dogovorComment-data-block block',{'show': show}]" v-cloak>
  <!--���� ��������������-->
    <div @click="blockToggle('dogovorComment')"
         class="block-toggle-bar align-center justify-between">
      <div class="block-name align-center justify-center">
        <icon name="comment" width="20px" height="20px" fill="var(--white-color)" fill-opacity="0.7"/>
        <span class="ml-8">{{ localizeList.dogovorComment }}</span>
      </div>
      <icon name="angle" width="12px" height="8px" fill="var(--white-color)" class="angle-icon" />
    </div>
    <div v-show="show" class="dogovorComment-data-content">
      <div class="dogovorComment-form-wrap">
          <FormTextArea :rows="4" :label="localizeList.dogovorComment" @input="commentInput"></FormTextArea>
      </div> 
    </div>
  </div>
</template>

<script>

export default {
  name: "dogovorComment",
  props: {
    isLoaded:{
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: false
    },
    comment:{
      type: String,
      default: ""
    }
  },
  mounted() {
    this.inputValue = this.comment;
  },
  watch:{

  },
  methods: {
    
    commentInput(value){
      this.$emit("input", value);
    },
    blockToggle() {
      this.$emit("toggle", !this.show)
    },
  }
}

</script>

<style scoped>

.block {
  background: var(--white-color);
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.11);
  border-radius: 4px;
  margin-bottom: 12px;
  transition: all .3s;
}

.block .block-toggle-bar {
  border-radius: 4px;
  background: var(--primary-color);
  padding: 12px 16px;
  cursor: pointer;
}

.block.show .block-toggle-bar {
  border-radius: 4px 4px 0 0;
}

.block .block-toggle-bar .block-name span {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: var(--white-color);
}

.block .block-toggle-bar .angle-icon {
  transform: rotate(0deg);
  transition: all .2s;
}

.block.show .block-toggle-bar .angle-icon {
  transform: rotate(180deg);
  transition: all .2s;
}

.basket .dogovorComment-data-block .dogovorComment-form-wrap {
  padding: 24px 28px;
}

.basket .dogovorComment-data-block .dogovorComment-form-wrap:not(:last-child) {
  border-bottom: 1px dashed var(--lighten-4-color);
}

.basket .dogovorComment-data-block .dogovorComment-form-wrap .title {
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #1D1D1D;
}

.basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 24px;
}

.ie .basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form {
  display: flex;
  flex-wrap: wrap;
}

.ie .basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form .field-wrap {
  width: 32%;
  margin-right: 1%;
}

.basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form .group-field {
  display: grid;
  grid-template-columns: 1fr 60px;
  grid-gap: 20px;
}

.ie .basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form .group-field {
  display: flex;
}

.ie .basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form .group-field .field-wrap:last-child {
  width: 60px;
  margin-left: 2%;
}

.ie .basket .dogovorComment-data-block .dogovorComment-form-wrap .dogovorComment-form .group-field .field-wrap:first-child {
  width: 100%;
  margin-right: 0;
}

.basket .dogovorComment-data-block .dogovorComment-service-wrap {
  background: var(--lighten-2-color);
  border-radius: 6px;
  padding: 16px;
  margin-top: 20px;
}

.basket .dogovorComment-data-block .dogovorComment-service-wrap .dogovorComment-service {
  display: grid;
  grid-template-columns: minmax(250px, auto) 1fr;
  grid-gap: 20px;
}

.ie .basket .dogovorComment-data-block .dogovorComment-service-wrap .dogovorComment-service {
  display: flex;
}

.ie .basket .dogovorComment-data-block .dogovorComment-service-wrap .dogovorComment-service .dogovorComment-service-name {
  min-width: 250px;
  margin-right: 20px;
}

.basket .dogovorComment-data-block .dogovorComment-service-wrap .dogovorComment-service:not(:last-child) {
  margin-bottom: 12px;
}

.basket .dogovorComment-data-block .dogovorComment-service-wrap .dogovorComment-service /deep/ .base-select .select {
  background-color: var(--white-color);
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 26px;
}
</style>